import React from 'react';

import { RelationStatus } from '../../types/businessRelations';
import StatusRelationsTab from '../shared/StatusRelationsTab';

const PausedAccounts: React.FC = () => {
  return (
    <StatusRelationsTab
      status={RelationStatus.DELETED}
      title="Empresas eliminadas"
      emptyStateType="deleted"
      showDaysUntilMonthEnd={false}
    />
  );
};

export default PausedAccounts;
